if( $('.module-ministrie-page-header__young--title') ) {
    $(window).on('scroll', function() {
        $('.module-ministrie-page-header__young--title').css({
            'transform': 'translateY(-' + $(this).scrollTop()/2 + 'px)',
        });
    });
}

if( $('.module-ministrie-page-header') ) {
    $(window).on('scroll', function() {
        $('.module-ministrie-page-header').css({
            'background-position-y': $(this).scrollTop()/2 + '%)',
        });
    });
}
